import React from 'react'
import { Link } from 'react-router-dom';

function Top() {
    const email = "usdigitalmarketing.us@gmail.com";
    const phoneNumber = "+17022967702";

    const openWhatsApp = () => {
        window.open(`https://wa.me/${phoneNumber}`, '_blank');
    };

    return (
        <>
            <div className="pre-header">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-8 col-sm-8 col-7">
                            <ul className="info">
                                <li><Link to={`mailto:${email}`}><i className="fa fa-envelope"></i>{email}</Link></li>
                                <li><Link style={{ textDecoration: "underline", cursor: "pointer" }} onClick={openWhatsApp}>
                                    <i className="fa fa-phone"></i>+1(702) 296-7702</Link></li>
                            </ul>
                        </div>
                        <div className="col-lg-4 col-sm-4 col-5">
                            <ul className="social-media">
                                <li><Link to="/"><i className="fa fa-facebook"></i></Link></li>
                                <li><Link to="/"><i className="fa fa-linkedin"></i></Link></li>
                                <li><Link to="/"><i className="fa fa-twitter"></i></Link></li>
                                <li><Link to={`mailto:${email}`}><i className="fa fa-envelope"></i></Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Top;